<template>
    <div class="app">
        <AppHeader :changePwd="changePwd"/>
        <div class="app-body">
            <Sidebar/>
            <main class="main">
                <breadcrumb :list="list"/>
                <div class="container-fluid">
                    <router-view></router-view>
                </div>
            </main>
        </div>
        <AppFooter/>
        <Modal v-model="changePwd.can" title="修改密码" @on-ok="changePassword">
            <label> 原密码</label><br/>
            <Input type="password" :maxlength='50' v-model.trim="changePwd.oldPwd"
                   style="width:490px"></Input><br/><br/>
            <label> 新密码</label><br/>
            <Input type="password" :maxlength='50' v-model.trim="changePwd.newPwd"
                   style="width:490px"></Input><br/><br/>
            <label> 确认新密码</label><br/>
            <Input type="password" :maxlength='50' v-model.trim="changePwd.newPwdAgain"
                   style="width:490px"></Input><br/><br/>
        </Modal>
    </div>
</template>

<script>
    import AppHeader from '../components/Header'
    import Sidebar from '../components/Sidebar'
    import AppFooter from '../components/Footer'
    import Breadcrumb from '../components/Breadcrumb'
    import {changePass} from 'api/adminUser'

    export default {
        name: 'full',
        components: {
            AppHeader,
            Sidebar,
            AppFooter,
            Breadcrumb
        },
        data() {
            return {
                changePwd: {
                    can: false,
                    oldPwd: '',
                    newPwd: '',
                    newPwdAgain: '',
                },

            }
        },
        methods: {
            changePassword() {
                if (this.changePwd.oldPwd.length == 0) {
                    this.$Message.error('请输入原密码！');
                    return;
                }
                if (this.changePwd.newPwd.length < 6) {
                    this.$Message.error('密码长度需要不小于6位！');
                    return;
                }
                if (this.changePwd.newPwd != this.changePwd.newPwdAgain) {
                    this.$Message.error('请确认两次输入密码相同！');
                    return;
                }
                changePass(this.changePwd.oldPwd, this.changePwd.newPwd).then(response => {
                    if (response.data.status == 0) {
                        this.Logout();
                        this.$Message.info('修改密码成功,请重新登录！');
                    } else {
                        this.$Message.error('修改密码失败！');
                    }
                });
            },
            Logout() {
                this.$store.dispatch('LogOut').then(() => {
                    this.$router.push({path: '/login'});
                }).catch(err => {
                    this.$Message.error(err);
                });
            },
        },

        computed: {
            name() {
                return this.$route.name
            },

            list() {
                return this.$route.matched
            },
        }
    }
</script>



// WEBPACK FOOTER //
// Full.vue?b2e07752